import script from "./LlMenu.vue?vue&type=script&setup=true&lang=js"
export * from "./LlMenu.vue?vue&type=script&setup=true&lang=js"

import "./LlMenu.vue?vue&type=style&index=0&id=2b55f726&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2b55f726"]])

export default __exports__